__turbopack_context__.v({
  "button": "phone-verification-module-scss-module__NSWfwG__button",
  "checkboxContainer": "phone-verification-module-scss-module__NSWfwG__checkboxContainer",
  "checkmark": "phone-verification-module-scss-module__NSWfwG__checkmark",
  "codeInfo": "phone-verification-module-scss-module__NSWfwG__codeInfo",
  "codeInput": "phone-verification-module-scss-module__NSWfwG__codeInput",
  "copy": "phone-verification-module-scss-module__NSWfwG__copy",
  "customCheckbox": "phone-verification-module-scss-module__NSWfwG__customCheckbox",
  "dialog": "phone-verification-module-scss-module__NSWfwG__dialog",
  "dialogCloseButton": "phone-verification-module-scss-module__NSWfwG__dialogCloseButton",
  "dialogContent": "phone-verification-module-scss-module__NSWfwG__dialogContent",
  "dialogOverlay": "phone-verification-module-scss-module__NSWfwG__dialogOverlay",
  "dialogTitle": "phone-verification-module-scss-module__NSWfwG__dialogTitle",
  "disabled": "phone-verification-module-scss-module__NSWfwG__disabled",
  "disclaimer": "phone-verification-module-scss-module__NSWfwG__disclaimer",
  "error": "phone-verification-module-scss-module__NSWfwG__error",
  "footer": "phone-verification-module-scss-module__NSWfwG__footer",
  "inputContainer": "phone-verification-module-scss-module__NSWfwG__inputContainer",
  "phoneInput": "phone-verification-module-scss-module__NSWfwG__phoneInput",
  "phoneVerification": "phone-verification-module-scss-module__NSWfwG__phoneVerification",
  "prefillButton": "phone-verification-module-scss-module__NSWfwG__prefillButton",
  "resendButton": "phone-verification-module-scss-module__NSWfwG__resendButton",
  "termsText": "phone-verification-module-scss-module__NSWfwG__termsText",
  "title": "phone-verification-module-scss-module__NSWfwG__title",
  "updatePhoneButton": "phone-verification-module-scss-module__NSWfwG__updatePhoneButton",
  "wrongNumber": "phone-verification-module-scss-module__NSWfwG__wrongNumber",
});
